import React from 'react';
import styled from 'styled-components';

const ImgCss = styled.div`
    background-image: url(${({ src }) => src});
    position: relative;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: ${({ dim }) => dim}em;
    height: ${({ dim }) => dim}em;
`;

const Img = ({ src, dim = 5, ...props }) => {
    return (
        <ImgCss src={src} dim={dim} {...props} />
    );
}

export default Img;